import cartRoutes from 'bento-ordering/cart/routes';
import locationRoutes from 'bento-ordering/locations/routes';
import menuRoutes from 'bento-ordering/menus/routes';
import groupOrderRoutes from 'bento-ordering/group_ordering/routes';

const routes = [
  ...groupOrderRoutes,
  ...cartRoutes,
  ...locationRoutes,
  ...menuRoutes
];

export default routes;
